import React from "react";
import { Field } from "formik";
import VariableField from "components/util/schema_form/fields/variable/VariableField";
import l from "components/util/l";

const RulesField = ({
  flow,
  name,
  values,
  ruleMode,
  isSingleMode,
  setFieldValue,
  nodes = [],
  collections = [],
  dataReqs = {},
}) => {

  let rules = values[name] || [];
  rules = rules.reduce((acc, rule, index) => {

    if (rule.rule.type != ruleMode || rule.rule.settings.is_hidden || rule.action == "delete")
      return acc;

    acc.push({ rule, index });
    return acc;

  }, []);

  return <div>

    {
      ruleMode == "DATA" &&
      <div className="w-100 mb-3">
        <span>{l("Considerar estos datos en las respuestas de la IA%PA153")}</span>
      </div>
    }

    {
      !isSingleMode && ruleMode == "EXECUTION" && nodes.length == 0 &&
      <div className="text-center">
        {l("Ejecuta procesos específicos en tu solución, puedes ir a la sección de \"procesos\" y crear uno%PA159")}
      </div>
    }

    {
      ((!isSingleMode && ruleMode == "EXECUTION") || (ruleMode == "EXECUTION" && nodes.length > 0 && rules.length == 0)) &&
      <div>
        {l("Ejecuta procesos cuando el usuario escriba cierto texto%PA161")}
      </div>
    }

    {
      rules.map(({ rule, index }, idx, arr) => (
        <div key={`rule-${index}`} className="mb-2">

          <div className="d-flex align-items-center w-100">
            <div className="d-flex flex-column align-items-center mr-3 w-100">

              {
                ruleMode == "DATA" &&
                <VariableField
                  name={`${name}[${index}].rule.collection.query`}
                  dataReqs={dataReqs}
                  showNodeAddButton={false}
                  showCollectionCondition={true}
                  supportIterables={true}
                  enableAttributes={false}
                  flowId={flow.id}
                  value={values[name][index].rule.collection?.query || ""}
                  values={values}
                  setFieldValue={setFieldValue}
                />
                // <Field
                //   as="select"
                //   name={`${name}[${index}].rule.collection.id`}
                //   className="form-control">
                //   <option value="">{l("Selecciona una tabla%PA157")}</option>
                //   {
                //     collections.map(item =>
                //       <option
                //         key={item.id}
                //         value={item.id}
                //       >
                //         {item.uiSettings?.label || item.name}
                //       </option>
                //     )
                //   }
                // </Field>
              }

              {
                ruleMode == "EXECUTION" &&
                <div className="w-100">
                  {
                    !isSingleMode &&
                      <div className="d-flex align-items-center mb-1">
                        <div className="w-50 font-italic">
                          <span>{l("Ejecutar proceso:%PA154")}</span>
                        </div>
                        <Field
                          as="select"
                          name={`${name}[${index}].rule.node.id`}
                          className="form-control mb-2">
                          <option value="">{l("Selecciona un proceso%PA135")}</option>
                          {
                            nodes.map(item =>
                              <option
                                key={item.id}
                                value={item.id}>
                                {item.rootName}
                              </option>
                            )
                          }
                        </Field>
                    </div>
                  }

                  <div className="d-flex align-items-center">
                    <div className="w-50 font-italic">
                      <span>{l("Cuando el usuario escriba:%PA155")}</span>
                    </div>
                    <Field
                      name={`${name}[${index}].rule.content`}
                      className="form-control mr-1"
                      placeholder={l("Ej. Una pregunta, el nombre del proceso%PA156")}
                    />

                  </div>

                  {idx != arr.length - 1 ? <hr className="my-2" /> : <div className="my-2" />}


                </div>
              }

            </div>


            <div class="input-group-append ml-n1">
              <button
                type="button"
                className="btn text-secondary p-0 ml-3"
                onClick={() => {
                  const updatedRules = values[name].map((r, i) =>
                    i === index ? { ...r, action: "delete" } : r);
                  setFieldValue(name, updatedRules);
                }}
              >
                <i className="fa fa-trash" />
              </button>
            </div>

          </div>

        </div>
      ))
    }

    {(ruleMode == "DATA" || (ruleMode == "EXECUTION" && nodes.length > 0) || isSingleMode) ?
      <div class="form-group mb-4">
        <button
          type="button"
          className="btn btn-sm btn-link w-100 px-0"
          onClick={() => {
            setFieldValue(name, [
              ...(values[name] || []),
              {
                action: "create",
                rule: {
                  node_id: isSingleMode && nodes.length > 0 ? nodes[0].id : "",
                  content: "",
                  type: ruleMode,
                  settings: {
                    is_hidden: false,
                  }
                }
              }
            ]);
          }}
        >
          <div>
            <label className="py-1"
              style={{ cursor: "pointer" }}>
              <i className="fa fa-plus mr-1" />
              {ruleMode == "DATA" ? l("Agregar tabla%PA160") : l("Agregar regla%PA103")}
            </label>
          </div>
        </button>
      </div> :
      <div className="mb-5" />
    }

  </div>

}

export default RulesField;